import { Checkbox, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { DatagridHeaderProps, useListContext, useTranslate } from 'react-admin'

interface ExpandableDatagridHeaderProps extends DatagridHeaderProps {
    children?: React.ReactNode
}

const ExpandableDatagridHeader: React.FC<ExpandableDatagridHeaderProps> = ({
    children,
    ...props
}) => {
    const translate = useTranslate()
    const { selectedIds, data, onSelect } = useListContext()

    const allSelected = data && selectedIds.length === data.length && data.length > 0
    const someSelected = selectedIds.length > 0 && selectedIds.length < (data?.length || 0)

    const handleSelectAll = () => {
        if (allSelected) {
            onSelect([])
        } else {
            const allIds = data?.map((record) => record.id) || []
            onSelect(allIds)
        }
    }

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox"></TableCell>

                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={someSelected}
                        checked={allSelected}
                        onChange={handleSelectAll}
                        color="primary"
                        inputProps={{
                            'aria-label': 'select all items'
                        }}
                    />
                </TableCell>

                <TableCell sx={{ fontWeight: 700 }}>
                    {translate('manager.resources.rule.label')}
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>
                    {translate('manager.resources.rule.rule_inputs')}
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>
                    {translate('manager.resources.rule.actions_applied')}
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>
                    {translate('manager.resources.general.status')}
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>
                    {translate('manager.resources.general.actions')}
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

export default ExpandableDatagridHeader
